import React from 'react';

import QuestionContainer from '../components/Question/QuestionContainer.jsx';

// Mock props for preview mode - these won't be used due to preview mode logic
const mockProps = {
  questionsData: [],
  question: null,
  user: {},
  userSubscription: {},
  counters: {},
  previousQuestion: {},
  isLoadingQuestions: false,
  loadingFavoriteQuestions: false,
  isStudyingSubmittedQuestions: false,
  isStudyingFavoriteQuestions: false,
  isStudyingMyFavoriteQuestions: false,
  isStudyingMySubmittedQuestions: false,
  resetChapter: false,
  loadResetChapter: false,
  cantStudy: false,
  answerResponse: null,
  subscriptionActivationSucces: false,
  subscriptionActivationWaiting: false,
  subscriptionActivationMessage: '',
  favoriteQuestion: {},
  loadFavoriteQuestion: false,
  listFavoriteQuestions: [],
  breadcrumsQualsAndCerts: '',
  flashcard: false,
  showPdfViewer: false,
  pdfLink: '',
  errorMessageGetQuestion: '',

  // Mock functions that won't be called in preview mode
  cleanQuestions: () => {},
  getTrialUserProgress: () => {},
  getQuestionsByRate: () => {},
  getQuestionsByChapter: () => {},
  getQuestionsByQuals: () => {},
  getQuestionsByFavoriteQuestions: () => {},
  getQuestionsByMyFavoriteQuestions: () => {},
  getQuestionsBySubmittedQuestions: () => {},
  getQuestionByMySubmittedQuestions: () => {},
  sendAnswer: () => {},
  setPreviousQuestion: () => {},
  setPreviousCounters: () => {},
  setQuestion: () => {},
  updateCounters: () => {},
  setBackedStateToQuestion: () => {},
  previousQuestionToActual: () => {},
  getAllFavoriteQuestions: () => {},
  updateUserAnswers: () => {},
  setIsStudyFavoriteQuestion: () => {},
  setIsStudyingSubmittedQuestions: () => {},
  setIsStudyingMyFavoriteQuestions: () => {},
  setIsStudyingMySubmittedQuestions: () => {},
  breadcrumsQualsAndCertsAction: () => {},
  checkChapterInReview: () => {},
  openPdfViewer: () => {},
  getPdfByReference: () => {},
  activateSubscription: () => {},
  clearAnswerResponse: () => {},
  setFavoriteMessage: () => {},
  setFavoriteMessageAction: () => {},
  getCountQuestions: () => {},
  setCountQuestions: () => {},
  addCountQuestions: () => {},
  getRecaptchaTime: () => {},
  setRecaptchaTime: () => {},
  setResetChapter: () => {},
};

class QuestionPreviewContainer extends React.Component {
  render() {
    return (
      <div>
        <QuestionContainer
          {...mockProps}
          location={this.props.location}
          history={this.props.history}
        />
      </div>
    );
  }
}

export default QuestionPreviewContainer;
